import { postData } from "@utils";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    userData: {},
    shallContentShowOverlay: false,
    basketDrawer: false,
    basketDelete: 0,
    basketDrawerTemporary: true,
    basketDrawerApproval: {},
    snackbar: {
      show: false,
      text: "deneme",
      color: "success",
    },
  },
  getters: {
    basketDrawer(state) {
      return state.basketDrawer;
    },
    basketDrawerApproval(state) {
      return state.basketDrawerApproval;
    },
    basketDelete(state) {
      return state.basketDelete;
    },
    basketLimitShow() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      let result = true;
      if (userData.role === "FIN") {
        result = false;
      }
      return result;
    },
  },
  mutations: {
    TOGGLE_CONTENT_OVERLAY(state, value) {
      state.shallContentShowOverlay = value !== undefined ? value : !state.shallContentShowOverlay;
    },
    TOGGLE_BASKET_DRAWER(state, value) {
      state.basketDrawer = value;
    },
    TOGGLE_BASKET_DRAWER_APPROVAL(state, value) {
      state.basketDrawerApproval = value;
    },
    TOGGLE_BASKET_DELETE(state, value) {
      state.basketDelete = value;
    },
    USER_DATA(state, value) {
      state.userData = value;
    },
    TOGGLE_BASKET_DRAWER_TEMPORARY(state, value) {
      state.basketDrawerTemporary = value;
    },
    TOGGLE_SNACKBAR(state, value) {
      state.snackbar.show = true;
      state.snackbar.text = value.text;
      state.snackbar.color = value.color;
    },
  },
  actions: {
    fetchCustomersBySalDept(ctx) {
      return new Promise((resolve, reject) => {
        postData({
          method: "getCustomersBySalDept",
          type: "select",
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchLogout() {
      return new Promise((resolve, reject) => {
        postData({
          method: "logout",
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
